import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'src/taskpane/utility/bem';
import Select from 'react-select';
import Button from 'src/taskpane/shared/Button';
import { CmicContext } from 'src/taskpane/context/CmicContext';
import './styles.scss';


const className = cn('cloud-login');
const el = (name, mod) => cn(className, name, mod);

const CloudLogin = ({
    ActionRoleContainer,
    customDropDownStyles,
    handleCloudSubmit,
    handleDropValueChange,
    handleDynamicEnvironmentURL,
    handleOnFocus,
    handleRoleChange,
    invalidCustomStyles,
    isSubmitted,
}) => {

    const {
        currentOfficeTheme,
        serverType,
    } = useContext(CmicContext);

    return (
        <div className={className}>
            <div className={el('content')}>
                <div className={el('header')}>
                    Are you a&nbsp;<div className={el('link')}>Cloud</div>&nbsp;customer?
                </div>
                <div className={el('description')}>
                    Cloud customers can use their CMiC Tenant information or a Microsoft account to sign in.
                </div>

                <ActionRoleContainer />

                <div className={el('select-container')}>
                    <Select
                        value={serverType.data?.url ? serverType.data : ''}
                        placeholder="Select client location"
                        label="Client location"
                        id="client_location"
                        options={handleDynamicEnvironmentURL()}
                        errorMessage={serverType.err}
                        onChange={handleDropValueChange}
                        onFocus={handleOnFocus}
                        styles={
                            serverType.data.label === '' && isSubmitted === true
                                ? invalidCustomStyles(currentOfficeTheme)
                                : customDropDownStyles(currentOfficeTheme)
                        }
                        aria-required
                        aria-label="Select client location"
                    />
                </div>

                <Button text="Go" onClick={handleCloudSubmit} disabled={!serverType?.data?.url} />
            </div>
            <div className={el('footer')}>
                <Button
                    customClasses={el('button')}
                    variant="secondary"
                    text="No, I'm not a Cloud Customer"
                    onClick={handleRoleChange}
                />
            </div>
        </div>
    );
};

export default CloudLogin;

CloudLogin.propTypes = {
    ActionRoleContainer: PropTypes.elementType.isRequired,
    customDropDownStyles: PropTypes.func.isRequired,
    handleCloudSubmit: PropTypes.func.isRequired,
    handleDropValueChange: PropTypes.func.isRequired,
    handleDynamicEnvironmentURL: PropTypes.func.isRequired,
    handleOnFocus: PropTypes.func,
    handleRoleChange: PropTypes.func.isRequired,
    invalidCustomStyles: PropTypes.func.isRequired,
    isSubmitted: PropTypes.bool,
};